import { render, staticRenderFns } from "./articleProgress.vue?vue&type=template&id=dc98c442"
import script from "./articleProgress.vue?vue&type=script&lang=js"
export * from "./articleProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports